"use client";
import React, { FC, useEffect } from "react";

interface FocusHeadingProps {
  children: React.ReactNode;
}
const FocusHeading: FC<FocusHeadingProps> = ({ children }) => {
  useEffect(() => {
    const h1 = document.getElementsByTagName("h1")[0];
    if (h1) {
      h1.setAttribute("tabindex", "-1");
      h1.focus({
        preventScroll: false,
      });
    }
  }, []);
  return children;
};

export default FocusHeading;
